import React from "react";
import { Col, Row } from "reactstrap";

const Dashboard = () => {
  return (
    <>
      <div className="page-content p-4">
        <Row>
          <Col xxl={12}>Sponsors Dashboard</Col>
        </Row>
      </div>
    </>
  );
};

export default Dashboard;
